module.exports = __webpack_public_path__ + "static/media/pg08.3b078776.jpg";